import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import { Routes_path } from "components/routerApp";

const OrdiniLavoroPageBreadcrumbs = () => {
    return (
        <Breadcrumbs aria-label="breadcrumb">
            <Link
                to={Routes_path.HOME}
                style={{ textDecoration: "none", color: "inherit" }}
            >
                Home
            </Link>
            <Typography color="text.primary" fontWeight="bold">
                Ordini di Lavoro
            </Typography>
        </Breadcrumbs>
    );
};

export default OrdiniLavoroPageBreadcrumbs;